































import { defineComponent, PropType } from '@vue/composition-api'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import { BImg } from 'bootstrap-vue'
import PostStore from '@/store/socialStream/socialStreamPost'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'

export default defineComponent({
  name: 'PostDetails',
  components: { BImg },
  computed: {
    calculateHeight(): string {
      return '100%'
      const heightInPixels = Math.ceil((window.innerHeight - 200) / 8)
      return `${heightInPixels}px`
    },
    calculateMaxWidth(): string {
      console.log(window.innerWidth)
      const widthInPixels = Math.ceil((window.innerWidth) / 6)
      return `${widthInPixels}px`
    },
    post() {
        return PostStore.state.postData
    },
    assignedProductsCnt(): number {
      return CatalogItemsLinkerStore.state.linkedIds.length
    }
  },
  methods: {
  },
})
